function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import * as httpProtocol from '@shared/services/http/httpProtocol';
import { logError } from '@shared/utils/httpClientUtil';
const commonHttpOptions = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: httpProtocol.AuthenticationTypes.Spza,
    setBearerHeader: true
};
export const UserReviewQueryStrings = {
    OfferId: 'offer_id',
    ApiVersion: 'api-version',
    Source: 'source',
    ReviewId: 'review_id'
};
export function get(_) {
    return _get.apply(this, arguments);
}
function _get() {
    _get = _async_to_generator(function*({ offerId, reviewsAPI, reviewsAPIVersion, source }) {
        try {
            return yield httpProtocol.get(`${reviewsAPI}/private/user`, commonHttpOptions).addQueryEntry(UserReviewQueryStrings.OfferId, offerId).addQueryEntry(UserReviewQueryStrings.Source, source).addQueryEntry(UserReviewQueryStrings.ApiVersion, reviewsAPIVersion).request();
        } catch (e) {
            logError('userReviewRestClient.getUserReview', e);
            throw e;
        }
    });
    return _get.apply(this, arguments);
}
export function submit({ reviewsAPI, reviewsAPIVersion, content, isAnonymous, rating, reviewId, sendEmailConsent, title, source, offerId }) {
    try {
        return httpProtocol.post(`${reviewsAPI}/private`, commonHttpOptions).addQueryEntry(UserReviewQueryStrings.ApiVersion, reviewsAPIVersion).setData({
            content: content,
            is_anonymous: isAnonymous,
            rating,
            id: reviewId,
            title,
            send_email_consent: sendEmailConsent,
            source,
            offer_id: offerId,
            offer_type: 'Application'
        }).request();
    } catch (e) {
        logError('userReviewRestClient.updateReview', e);
        throw e;
    }
}
export function update(_) {
    return _update.apply(this, arguments);
}
function _update() {
    _update = _async_to_generator(function*({ reviewsAPI, reviewsAPIVersion, content, isAnonymous, rating, reviewId, sendEmailConsent, title }) {
        try {
            return yield httpProtocol.patch(`${reviewsAPI}/private/update`, commonHttpOptions).addQueryEntry(UserReviewQueryStrings.ApiVersion, reviewsAPIVersion).setData({
                content: content,
                is_anonymous: isAnonymous,
                rating,
                id: reviewId,
                title,
                send_email_consent: sendEmailConsent
            }).request();
        } catch (e) {
            logError('userReviewRestClient.updateReview', e);
            throw e;
        }
    });
    return _update.apply(this, arguments);
}
export function remove(_) {
    return _remove.apply(this, arguments);
}
function _remove() {
    _remove = _async_to_generator(function*({ reviewsAPI, reviewsAPIVersion, reviewId }) {
        try {
            return yield httpProtocol.del(`${reviewsAPI}/private/delete_my_review`, commonHttpOptions).addQueryEntry(UserReviewQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(UserReviewQueryStrings.ReviewId, reviewId).request();
        } catch (e) {
            logError('userReviewRestClient.updateReview', e);
            throw e;
        }
    });
    return _remove.apply(this, arguments);
}
